
// composables/useAuth.js
import { getCurrentInstance, computed } from 'vue'

export function useAuth() {
  const instance = getCurrentInstance()
  const keycloak = instance.appContext.config.globalProperties.$keycloak
  
  // Computed koji će uvijek dohvaćati trenutni status
  const isAuthenticated = computed(() => {
    return keycloak?.authenticated ?? false
  })
  
  return {
    keycloak,
    isAuthenticated, 
    login: () => keycloak.login(),
    logout: () => keycloak.logout()
  }
}